import React from 'react';

export type XAxisMode =
  | 'step'
  | 'relativeTime'
  | 'absoluteTime'
  | 'timeSeries'
  | 'customExpressionSeries';

// 'symlog' is sign(x) * log(1 + |x|). It keeps 0 and negative values on the axis.
// Only line chart X axes render it; elsewhere it falls back to linear.
export type AxisScale = 'linear' | 'logarithmic' | 'symlog';
export type AxisRange = [number | undefined, number | undefined];
export type AxisRangeHandlerParams = {
  min: number | undefined;
  max: number | undefined;
};

export function isSimpleRange(range: AxisRange): range is [number, number] {
  return range[0] !== undefined && range[1] !== undefined;
}

export const isAxisScale = (input: string): input is AxisScale =>
  input === 'linear' || input === 'logarithmic' || input === 'symlog';

export const isStepAxisMode = (mode: XAxisMode): mode is 'step' => {
  return mode === 'step';
};

export const linearLogarithmicLabelMap = new Map<AxisScale, string>([
  ['linear', 'Linear'],
  ['logarithmic', 'Logarithmic'],
]);

export type AxisRangeValues = {
  minValue?: number;
  maxValue?: number;
  error?: boolean;
  errorMessage?: string;
  resetValues: () => void;
  handleMinChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleMaxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export enum ConfigurationMode {
  Add = 'add',
  Edit = 'edit',
}
